import { HttpService } from '@/infra/http'
import type { TGetSimulacaoResponse } from '@/types/simulacao'

export class GetSimulacoesPorIds extends HttpService {
  execute = async (ids: string[]) => {
    return this.http.get<TGetSimulacaoResponse[]>(`/api/v2/Simulacao/lista`, {
      params: { ids },
      paramsSerializer: { indexes: null },
    })
  }
}
